<script setup lang="ts">
  import { useCurrencyList } from '@/models/currency'

  defineProps<{
    error?: string | string[],
    required?: boolean,
  }>()

  const modelValue = defineModel<string>({ required: true })

  const { currencies, loading, getData } = useCurrencyList()
  getData()
</script>

<template>
  <app-select
    v-model="modelValue"
    label="Mata Uang"
    :loading="loading"
    :required="required"
    :error="error">
    <option :value="0">
      - Pilih Mata Uang -
    </option>
    <option
      v-for="currency in currencies"
      :key="currency.code"
      :value="currency.code">
      {{ currency.code }} - {{ currency.name }}
    </option>
  </app-select>
</template>
